import React from 'react'
import PropTypes from 'prop-types'
import SegmentBadge from './SegmentBadge'
import { MAX_SEGMENT_PAGES, describePages } from './segments'

const plural = (count, word) => `${count} ${word}${count === 1 ? '' : 's'}`

// Where each piece of a boxed page lands: "page 5, box 2 of 3".
const boxedText = (segments, index) => {
  const { page } = segments[index].pieces[0]
  const onPage = segments.filter((segment) => segment.pieces[0].box && segment.pieces[0].page === page)
  const position = onPage.indexOf(segments[index]) + 1
  return `page ${page}, box ${position} of ${onPage.length}`
}

// What the split will upload, one row per document, so the result reads at a glance beside the pages.
const SplitStatusSidebar = ({ segments, pageCount, skipped, noun, colorFor, onSelect }) => {
  const Noun = noun.charAt(0).toUpperCase() + noun.slice(1)

  return (
    <aside
      className="border-start bg-light p-3 overflow-auto flex-shrink-0"
      style={{ width: 300 }}
      data-testid="splitter-status"
    >
      <div className="mb-3">
        <div className="fs-2 fw-bold lh-1" data-testid="splitter-status-count">{segments.length}</div>
        <div className="small text-muted">
          {noun}{segments.length === 1 ? '' : 's'} from {plural(pageCount, 'page')}
        </div>
      </div>

      <ol className="list-unstyled mb-3">
        {segments.map((segment, index) => {
          const boxed = !!segment.pieces[0].box
          const overLimit = segment.pieces.length > MAX_SEGMENT_PAGES
          return (
            <li key={index} className="mb-1">
              <button
                type="button"
                className="btn btn-light text-start w-100 d-flex align-items-center gap-2 border"
                onClick={() => onSelect(segment.pieces[0].page)}
                data-testid={`splitter-status-${index + 1}`}
              >
                <SegmentBadge color={colorFor(index)}>{Noun} {index + 1}</SegmentBadge>
                <span className="small">
                  {boxed ? boxedText(segments, index) : describePages(segment.pieces.map(({ page }) => page))}
                </span>
                {overLimit && <span className="small text-danger ms-auto">Over {MAX_SEGMENT_PAGES} pages</span>}
              </button>
            </li>
          )
        })}
      </ol>

      {skipped.length > 0 && (
        <div className="small text-muted" data-testid="splitter-status-skipped">
          Skipped: {describePages(skipped)}
        </div>
      )}
    </aside>
  )
}

SplitStatusSidebar.propTypes = {
  segments: PropTypes.arrayOf(PropTypes.shape({ pieces: PropTypes.array.isRequired })).isRequired,
  pageCount: PropTypes.number.isRequired,
  skipped: PropTypes.arrayOf(PropTypes.number).isRequired,
  noun: PropTypes.string.isRequired,
  colorFor: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
}

export default SplitStatusSidebar
